import moment from 'moment'

import { calendarPopoverEventTimeFormat as eventTimeFormat } from '../../configuration/configs'
import { dateKeyFormat } from '../../configuration/calendar'

export function getEventSchedule(events) {
  let eventSchedule = {}

  if (events) {
    for (let eventKey in events) {
      const currentEvent = events[eventKey]

      if (currentEvent && currentEvent.schedule) {
        for (const scheduleKey in currentEvent.schedule) {
          if (currentEvent.title) {
            const dateKey = moment(currentEvent.schedule[scheduleKey].startDate).format(
              dateKeyFormat
            )
            let eventTime = moment(currentEvent.schedule[scheduleKey].startDate).format(
              eventTimeFormat
            )

            if (currentEvent.isAllDay) {
              eventTime = 'All Day'
            }

            const formattedCurrentEvent = {
              id: currentEvent.id,
              title: currentEvent.title,
              categories: currentEvent.categories,
              location: currentEvent.location,
              eventTime,
              startDate: currentEvent.schedule[scheduleKey].startDate,
              endDate: currentEvent.schedule[scheduleKey].endDate,
              marketingLink: currentEvent.marketingLink,
              isInternalLink: currentEvent.isInternalLink,
            }

            const currentEventSchedule = eventSchedule[dateKey] ? eventSchedule[dateKey] : []
            currentEventSchedule.push(formattedCurrentEvent)
            eventSchedule = {
              ...eventSchedule,
              [dateKey]: currentEventSchedule,
            }
          }
        }
      }
    }
  }

  return eventSchedule
}
